// @flow

type PropsType = {
    $element: HTMLElement,
};

class Favourite {
    props: PropsType;
    $el: HTMLElement;
    active: boolean;
    href: string;

    constructor(props: PropsType) {
        this.$el = props.$element;
        this.href = this.$el.getAttribute("href");
        this.active = this.$el.classList.contains("is-active");

        console.log(this.$el);

        this.attachEvents();
        this.init();
    }

    attachEvents() {
        if (this.$el && this.href) {
            this.$el.addEventListener("click", event => {
                event.stopPropagation();
                event.preventDefault();
                this.setFavourite(!this.active);
            });
        }
    }

    init() {}

    setFavourite(setActive) {
        const href = this.$el.getAttribute("href");
        console.log(href);

        // mock drupal response data
        // let data = [
        //     {
        //         command: "insert",
        //         method: "replaceWith",
        //         selector: ".js-flag-favourite-704",
        //         data:
        //             "\u003Cspan class=\u0022flag flag-favourite flag-favourite-704 js-flag-favourite-704 action-unflag\u0022\u003E\u003Ca title=\u0022\u0022 href=\u0022/TEST/unflag/favourite/704?destination=/news/covid-19-shifting-disease-and-vaccination-coverage-rates-worldwide-how-australia-affected\u0026amp;token=J5efpBiudRBi8kcQwhfYLT2h_-KBRK7MR9y50fz56ac\u0022 class=\u0022use-ajax\u0022 rel=\u0022nofollow\u0022\u003E\u003Cspan class=\u0022icon icon-favourite\u0022\u003E\u003C/span\u003E\u003C/a\u003E\u003C/span\u003E",
        //         settings: null,
        //     },
        // ];

        fetch(`${href}&_wrapper_format=drupal_ajax`, { method: "POST" })
            .then((response: any): any => response.json())
            .then((data: any) => {
                if (
                    data[0] &&
                    data[0].data &&
                    data[0].method === "replaceWith"
                ) {
                    // find anchor and href from return html string
                    const tempEl = document.createElement("a");
                    tempEl.innerHTML = data[0].data;
                    const anchor = tempEl.querySelector("a");
                    const newHref = anchor.getAttribute("href");

                    // if new href found, set new href and toggle active state
                    if (newHref) {
                        this.$el.setAttribute("href", newHref);
                        this.active = setActive;

                        if (this.active) {
                            this.$el.classList.add("is-active");
                        } else {
                            this.$el.classList.remove("is-active");
                        }
                    }
                }
            })
            .catch((err: any) => {
                console.log(err);
            });
    }
}

export default Favourite;
